export default [
  '#2A9D8F',
  '#24C39A',
  '#E9C469',
  '#F4A260',
  '#E76F50',
  '#994499',
  '#6633CC',
  '#E67300',
  '#8B0707',
  '#18658D',
  '#1B8090',
  '#20A895',
  '#F0F3BD',
  '#945254', // Pantone Colour of the Year 2015
  '#8BAAD8', // Pantone Colour of the Year 2016
  '#AD5D98', // Pantone Colour of the Year 2014
  '#1A9B77', // Pantone Colour of the Year 2013
  '#EF5442', // Pantone Colour of the Year 2012
  '#DA4F70', // Pantone Colour of the Year 2011
  '#46B4A9', // Pantone Colour of the Year 2010
  '#86AF49', // Pantone Colour of the Year 2017
  '#F0DCDD', // Pantone Colour of the Year 2016
  '#604D8D', // Pantone Colour of the Year 2018 :D
  '#316395', // random google colour
  '#329262',
  '#5574A6',
  '#3B3EAC'
]
